import FoodItemBanner, { FoodItemBannerProps } from './FoodItemBanner';

export type { FoodItemBannerProps };
export default FoodItemBanner;
